import React, { FC } from 'react';
import { SecretaryCardList } from './secretary-card-list';
import { SecretaryCard } from '../secretary.container';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';

export interface SecretaryCardListContainerProps {
  cards: SecretaryCard[];
}

export const SecretaryCardListContainer: FC<SecretaryCardListContainerProps> =
  ({ cards }) => {
    const history = useHistory();

    const redirect = (slug: string) => {
      history.push(ROUTES.DEPARTMENT_PAGE.replace(':orgao', slug));
    };

    return <SecretaryCardList cards={cards} redirect={redirect} />;
  };
